module.exports = __webpack_public_path__ + "img/resources2.f7094fff.svg";